import httpClient from '@/shared/http-eserv-client';

const appRelativeUrl = '/announcements';
export const announcementsAdminApi = {
  getAll: () => httpClient.get(`${appRelativeUrl}/All`)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return [];
    }),

  getById: (id) => httpClient.get(`${appRelativeUrl}/${id}`)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return null;
    }),

  save: (announcement) => httpClient.post(`${appRelativeUrl}`, announcement)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return null;
    }),
  update: (announcement) => httpClient.put(`${appRelativeUrl}`, announcement)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return null;
    }),
  delete: (id) => httpClient.delete(`${appRelativeUrl}/${id}`)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return null;
    }),
};

export const announcementsPublicApi = {
  getAnnouncements: () => httpClient.get(`${appRelativeUrl}`)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return [];
    }),
};
